<template>
    <div class="qingwu">
        <div class="admin_main_block">
            <div class="admin_main_block_top">
                <div class="admin_main_block_left">
                    <div><router-link to="/Admin/mend/form"><el-button type="primary" icon="el-icon-plus">添加</el-button></router-link></div>
                   <div><el-input v-model="where.F_VR_MINGC" placeholder="请输入灯名"></el-input></div>
                    <div><el-button icon="el-icon-search" @click="get_adv_list()">条件筛选</el-button></div>
                </div>

                <div class="admin_main_block_right">
                    <div><el-button type="danger" icon="el-icon-delete" @click="del(select_id)">批量删除</el-button></div>
                </div>
            </div>
            <div class="admin_table_main">
                <el-table :data="list" @selection-change="handleSelectionChange" >
                    <el-table-column type="selection"></el-table-column>
                    <!-- <el-table-column prop="id" label="#" fixed="left" width="70px"></el-table-column> -->
                    <el-table-column prop="id" label="#"  width="70px"></el-table-column>
                  <el-table-column prop="topic" label="TOPIC" ></el-table-column>
                    <el-table-column prop="dengm" label="灯名" ></el-table-column>
<!--                    <el-table-column prop="type" label="是否点亮"  ></el-table-column>-->
                  <el-table-column label="是否点亮">
                    <template slot-scope="scope">
                      <el-tag type="info" v-if="scope.row.type==1">未点亮</el-tag>
                      <el-tag type="warning" v-else>已点亮</el-tag>
                    </template>
                  </el-table-column>
                    <el-table-column prop="imei" label="IMEI"  ></el-table-column>
                  <el-table-column prop="iccid" label="ICCID"  ></el-table-column>
                  <el-table-column prop="imsi" label="IMSI"  ></el-table-column>
                  <el-table-column label="操作" fixed="right" width="230px">
                    <template slot-scope="scope">
                      <el-button icon="el-icon-edit" @click="$router.push({name:'mend_form',params:{id:scope.row.id}})">编辑</el-button>
                      <el-button type="danger" icon="el-icon-delete" @click="del(scope.row.id)">删除</el-button>
                    </template>
                  </el-table-column>


                </el-table>

                <div class="admin_table_main_pagination">
                    <el-pagination @current-change="current_change" background layout="prev, pager, next,jumper,total" :total="total_data" :page-size="page_size" :current-page="current_page"></el-pagination>
                </div>
            </div>
        </div>


      <!-- 调整资金弹出框 -->
      <el-dialog title="快递单号" :visible.sync="changeShow" width="30%">
        <el-form ref="form"  label-width="90px">
          <el-form-item label="微信选择" prop="shangj" @change="selectChange()">
            <el-select v-model="change_info.shangj" placeholder="请选择">
              <el-option label="请选择商家微信" :value="0"></el-option>
              <el-option v-for="(v,k) in shangj" :key="k" :label="v.nickname" :value="v.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
                <el-button @click="changeShow = false">取 消</el-button>
                <el-button type="primary" @click="change_start()">确 定</el-button>
        </span>
      </el-dialog>



    </div>
</template>

<script>
    export default {
        components: {},
        props: {},
        data() {
            return {
              changeShow:false, // 显示调整输入框
              change_info:{
                dingd_id:'',
                shangj:'',
              },
              mend:[],
              shangj:[],

                list:[],
                total_data:0, // 总条数
                page_size:20,
                current_page:1,
                select_id:'',
                adv_position_id:0,
                where:{
                },
            };
        },
        watch: {},
        computed: {},
        methods: {
          change_start:function(){
            this.change_info.dingd_id = this.dingd_id;
            this.$post(this.$api.adminChangesjwx,this.change_info).then(res=>{
              if(res.code == 200){
                this.changeShow = false;
                this.$message.success('修改成功');
                this.get_adv_list();
              }else{
                this.$message.error(res.msg);
              }
            });
          },
          change_user_money:function(id){
            this.dingd_id = id;
            this.changeShow = true;
          },
            handleSelectionChange:function(e){
                let ids = [];
                e.forEach(v => {
                    ids.push(v.id);
                });
                this.select_id = ids.join(',');
            },
            get_adv_list:function(){
                if(!this.$isEmpty(this.$route.params.adv_position_id)){
                    this.adv_position_id = this.$route.params.adv_position_id;
                }
                this.where.page = this.current_page;
                this.$get(this.$api.getMendList,this.where).then(res=>{
                    this.page_size = res.data.mend.per_page;
                    this.total_data = res.data.mend.total;
                    this.current_page = res.data.mend.current_page;
                    this.list = res.data.mend.data;
                    this.shangj = res.data.shangj;
                })

            },
            // 删除处理
            del:function(id){
                if(this.$isEmpty(id)){
                    return this.$message.error('请先选择删除的对象');
                }
                this.$post(this.$api.delMend,{id:id}).then(res=>{
                    if(res.code == 200){
                        this.get_adv_list();
                        return this.$message.success("删除成功");
                    }else{
                        return this.$message.error("删除失败");
                    }
                });
            },
            current_change:function(e){
                this.current_page = e;
                this.get_adv_list();
            },
        },
        created() {
            this.get_adv_list();
        },
        mounted() {}
    };
</script>
<style lang="scss" scoped>
</style>
